import * as React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { Grid } from '@material-ui/core';


interface Props {

};


const WashX: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);



    return (
        <Grid container direction="row" justify="flex-start" alignItems="stretch">
            <Grid item>WashX Home { user.displayName }</Grid>

        </Grid>
    )
}

export default WashX;